import { Activity } from "@/types/activity";
import "./styles.scss";
import { ProgressBar, Button } from "@/components";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";

interface ActivityDetailCardProps {
  activity: Activity;
}

export default function ActivityDetailCard({
  activity,
}: ActivityDetailCardProps) {
  const totalLessons = activity.totalLessons ?? 0;
  const progress = totalLessons > 0 ? (0 / totalLessons) * 100 : 0;

  const { activityValue, updateActivityValues } = useAuth();

  return (
    <div className="activity_card">
      <div className="top">
        <img src={activity.image ?? undefined} alt="" />
      </div>
      <div className="bottom">
        <h1>{activity.title}</h1>
        <h2>
          {activity?.completedLessons}/{activity?.totalLessons} lessons
        </h2>
        <ProgressBar height={16} percent={progress} />

        <p>{activity.description}</p>
        <Link
          to={`/activity/level/${activity.id}`}
          state={{ title: activity.title }}
        >
          <Button
            onClick={() =>
              updateActivityValues({ ...activityValue, levelId: activity.id })
            }
            variant="secondary"
          >
            Start
          </Button>
        </Link>
      </div>
    </div>
  );
}
